import i18next from 'i18next';
import { Vehicle } from '../@types/Vehicle';
import { sendRequest } from './http';
import { MarketCode } from '../@types/MarketCode';

const getValuation = async (
  url: string,
  registrationNumber: string,
  marketCode: MarketCode = 'SE'
) => {
  const params = new URLSearchParams();
  params.set('regNo', registrationNumber);
  params.set('marketCode', marketCode);

  return await sendRequest<Vehicle>({
    method: 'GET',
    url: `${url}/wip/external/vehicleenrichment?${params.toString()}`,
  });
};

export const getVehicleErrorMessage = (status?: number) => {
  switch (status) {
    case 404:
      return i18next.t('error.vehicle');
    default:
      return i18next.t('error.unspecific');
  }
};

export default getValuation;
